import React, { useEffect, useState } from "react";
import { Card, Row, Col, ListGroup } from "react-bootstrap";
import { authService } from "../services";

function Activity() {
  const [quadrenetProfile, setQuadrenetProfile] = useState(null);

  const getQuadranetProfileDetails = async () => {
    try {
      const res = await authService.getQuadranetProfile();
      if (res && res.data) {
        setQuadrenetProfile(res.data);
      }
    } catch (error) {
      console.log("Error fetching rewards list");
    }
  };

  useEffect(() => {
    getQuadranetProfileDetails();
  }, []);

  const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    const formattedDate = date.toLocaleDateString("en-GB"); // DD/MM/YYYY
    // const formattedTime = date.toLocaleTimeString("en-GB"); // HH:MM:SS
    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour:   "2-digit",
      minute: "2-digit",
      hour12: false      
    });
    return { formattedDate, formattedTime };
  };

  



  return (
    <div className="tab-content-container all-box88  bglc">
      <Card className="notification-all-box activtybar">
        <h5>Activity</h5>
        <p className="section-subtitle">
          Your summary of points earned and redeemed.
        </p>

        {quadrenetProfile?.points?.transactions?.length > 0 ? (
        <ListGroup variant="flush" >
         { quadrenetProfile.points.transactions.map((txn, index) => {
            const { formattedDate, formattedTime } = formatDateTime(txn.transactionDate);

            return (
              <ListGroup.Item
              key={index}
              className="customlist acc"
            >
              <div className="noti-design1">
                <div className="noti-design mobile-noti xc activityyys">
                  <div className="activiyt-3">
                        <span className="mobile-noti-date">{formattedDate}</span>
                        <span className="mx-3 mobile-noti-time">{formattedTime}</span>
                        <span className="text-truncate mobile-noti-title">{txn.transactionType}</span>
                  </div>

                    <div className="activiyt-1">
                    <span className="mobile-noti-date" >{txn.pointsChange} Points</span>
                    </div>
                </div>
              </div>
              </ListGroup.Item>
            );
    })}
          </ListGroup>
        ) : (
          <p className="text-center text-muted pt-4"> No transactions found.</p>
        )}
      </Card>
    </div>
  );
}

export default Activity;
